import { Component, Input, OnInit, inject } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Tenant, ListFilter } from '@parashift/shared/models';
import { TenantService, JsonApiQueryData } from '@parashift/shared/services';

@Component({
  selector: 'super-tenant',
  templateUrl: './super-tenant.component.html',
  imports: [FaIconComponent]
})
export class SuperTenantComponent implements OnInit {
  private tenantService = inject(TenantService);

  @Input() tenant: Tenant;

  superTenant: Tenant;

  ngOnInit() {
    this.getSuperTenant();
  }

  private getSuperTenant() {
    if (this.tenant.super_tenant_id) {
      const listFilter = new ListFilter({ filter: { id: this.tenant.super_tenant_id }});
      this.tenantService.lookupAll(listFilter).subscribe((result: JsonApiQueryData<Tenant>) => {
        const tenants = result.getModels();
        this.superTenant = tenants[0];
      });
    }
  }
}
